module.exports = __webpack_public_path__ + "static/img/logo.63b2722.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/developerHeader/img/logo.png
// module id = z4Eo
// module chunks = 1